<template>
<div class="text-white flex-1 col-span-1 border-0 rounded-t-xl overflow-hidden">
    <div class="bg-theme-green px-4 py-2 text-white">
        <div class="flex justify-between items-center">
            <div class="font-bold tracking-wider leading-tight text-2xl mt-0">
                {{ form.processor.value ? form.processor.value : 'Add New Processor'}}
            </div>
            <div class="flex items-end">
                <button @click.prevent="update()" class="  tracking-widest cursor-pointer bg-white py-2 px-4 rounded text-theme-green hover:bg-theme-darkgreen hover:text-white mr-3">
                SAVE
              </button>
              <button @click="deleteRecord()" class="cursor-pointer rounded-md bg-white text-theme-red py-2 px-4  hover:bg-theme-darkgreen hover:text-white mr-3">DELETE</button>
              <span @click.prevent="clearComponent" class="cursor-pointer rounded-md  text-white py-2 pl-1  hover:opacity-70">CLOSE</span>


                <!-- <mdicon @click.prevent="clearComponent" size="32" class="close-icon flex justify-end cursor-pointer hover:opacity-60 mb-2 " name="close" />
                <div class="flex justify-between">
                    <button @click="update()" class="h-10 hover:bg-theme-darkgreen border-0 hover:text-white rounded-md cursor-pointer text-green-400 bg-white py-2 px-4 uppercase font-semibold">SAVE</button>
                    <mdicon @click="deleteRecord()" name="trash-can-outline" class="hover:bg-theme-red hover:text-white del-icon border-0 rounded-md cursor-pointer text-theme-red bg-white ml-2 pt-2 py-1 px-1" />
                </div> -->

            </div>
        </div>
    </div>

    <div class="pt-3 bg-[#2B2C32] px-[16px] py-[16px] rounded-lg border-b border-l border-r border-theme-green rounded-t-none">

        <div class="flex xl:flex-row flex-col gap-3 items-start mb-3">

            <div class="w-full xl:w-1/2">
                <div :class="'input-wrapper ' + (form.processor.error_type)">
                    <label class="text-xs mb-1">Name:</label>
                    <select @change="validateFields(['processor'])" v-model="form.processor.value" class="block rounded bg-gray-black w-full">
                        <option disabled value="">--Select--</option>
                        <option value="moneris">Moneris</option>
                        <option value="clover">Clover</option>
                    </select>
                    <p class="field-error label-text mt-1" v-if="form.processor.error_message" v-text="form.processor.error_message"></p>
                </div>
            </div>

            <div class="w-full xl:w-1/2">
                <div :class="'input-wrapper ' + (form.terminalId.error_type)">
                    <label class="text-xs mb-1">Terminal ID:</label>
                    <input placeholder="Terminal id" @keyup="validateFields(['terminalId'])" v-model="form.terminalId.value" class="block rounded bg-gray-black w-full" type="text" />
                    <p class="field-error label-text mt-1" v-if="form.terminalId.error_message" v-text="form.terminalId.error_message"></p>
                </div>
            </div>
        </div>

        <div class="flex xl:flex-row flex-col gap-3 items-start mb-3">
            <div class="w-full xl:w-1/2" v-if="form.processor.value==='clover'">
                <div :class="'input-wrapper ' + (form.merchantId.error_type)">
                    <label class="text-xs mb-1">Merchant ID:</label>
                    <input placeholder="Merchant ID" @keyup="validateFields(['merchantId'])" v-model="form.merchantId.value" class="block rounded bg-gray-black w-full" type="text" />
                    <p class="field-error label-text mt-1" v-if="form.merchantId.error_message" v-text="form.merchantId.error_message"></p>
                </div>
            </div>

            <div class="w-full">
              <div class="flex xl:flex-row flex-col gap-3 mb-3">
                  <div class="w-full xl:w-1/2">
                      <label class="text-xs mb-1 mt-0">Status:</label>
                      <label class="flex items-center cursor-pointer xl:mt-2">
                          <input type="checkbox" v-model="form.active" class="hidden peer">
                          <div :class="'relative toggle-bg  border-2  h-6 w-11 rounded-full ' + (form.active ? 'bg-theme-green border-theme-green' : 'bg-[#F53333] border-[#F53333]')"></div>
                          <span class="ml-2 text-white text-sm font-medium uppercase" :class="form.active ? 'text-theme-green' : 'text-[#F53333]'">{{form.active ? 'ON' : 'OFF'}}</span>
                      </label>

                  </div>
                 
              </div>
            </div>

        </div>
    </div>
</div>
<ReturnConfirmModal v-if="deleteObj.modal" :obj="deleteObj.obj" :closeClick="closeDeleteModal" :actionClick="deleteNow" :heading="'You Are About To Delete ' + deleteObj.obj.merchantId " />
</template>

<script lang="ts">
import {
    defineComponent,
    ref
} from "vue"
import {
    mapGetters,
    mapActions,
    mapMutations
} from "vuex";
import LocationPosStationApis from "@/controllers/LocationPosStationApis";
import {
    useSnackbar
} from "vue3-snackbar";
import Helpers from '@/helpers';
import ReturnConfirmModal from "@/components/general/dialog/ReturnConfirmModal.vue";
import LocationPaymentProcessorApis from "@/controllers/LocationPaymentProcessorApis";
import Env from '@/env';

export default defineComponent({
    name: "LocationPosAdd",
    components: {
        ReturnConfirmModal
    },
    setup() {
        const snackbar = useSnackbar();
        const deleteObj = ref({
            modal: false,
            obj: {},
        });
        const cloverAccess = < any > ref({
            verified: false,
            accessCode: '',
        });
        const form = < any > ref({
            processor: {
                value: '',
                error_type: '',
                error_message: '',
                validations: ['required'],
            },
            merchantId: {
                value: '',
                error_type: '',
                error_message: '',
                validations: ['required'],
            },
            terminalId: {
                value: '',
                error_type: '',
                error_message: '',
                validations: ['required'],
            },
            active: false,
        });

        return {
            form,
            snackbar,
            deleteObj,
            cloverAccess
        };
    },
    props: {
        clearComponent: {
            type: Function,
            required: true,
        },
        item: {
            type: Object,
            required: true,
        },
    },

    watch: {
        'item'(val) {
            this.assignItemValue();
        },
        // terminalId cannot have whitespaces
        'form.terminalId.value'(val) {
            if (val) {
               // val = val.toLowerCase();
                val = val.replaceAll(/\s/g, '').trim();
                this.form.terminalId.value = val;
            } else {
                this.form.terminalId.value = '';
            }
        },
        // merchantId cannot have whitespaces
        'form.merchantId.value'(val) {
            if (val) {
               // val = val.toLowerCase();
                val = val.replaceAll(/\s/g, '').trim();
                this.form.merchantId.value = val;
            } else {
                this.form.merchantId.value = '';
            }
        },
    },

    computed: {
        ...mapGetters({

        }),
    },

    mounted() {
        this.assignItemValue();
    },

    methods: {

        assignItemValue() {
            this.form = Helpers.assignFormValues(this.form, this.item)
        },

        /**
         * Validation captures
         */
        async validateFields(fields) {
            let res = await Helpers.validateFormFields(this.form, fields);
            // capture the fields
            this.form = res.data;
            return res.error ? false : true;
        },

        /**
         * Update
         */
        async update() {
            let validate = false
            if(this.form.processor.value==='clover'){
                validate = await this.validateFields(['processor', 'merchantId', 'terminalId']);
            }else{
                validate = await this.validateFields(['processor', 'terminalId']);
            }

            if (!validate) {
                return;
            }
            this.va_spinner(true);
            let data = Helpers.getFormKeyValue(this.form)
            if(this.form.processor.value==='moneris'){
                delete data['merchantId']
            }
            let res = await LocationPaymentProcessorApis.update(this.item.id, data);
            this.va_spinner(false);
            this.snackbar.add({
                type: 'info',
                text: res.status == 200 ? res.data.message : Helpers.catchErrorMessage(res.response.data),
                duration: 3000,
            })
            if (res.status == 200) {
                this.clearComponent();
                this.emitter.emit("refresh-location-payment-processor-list", true);
            }
        },

        /**
         * Delete location tax
         */
        async deleteRecord() {
            this.deleteObj = {
                modal: true,
                obj: this.item,
            };
        },

        /**
         * Close delete modal
         */
        closeDeleteModal() {
            this.deleteObj = {
                modal: false,
                obj: {},
            };
        },

        /**
         * Delete Pos
         */
        async deleteNow(obj) {
            this.va_spinner(true);
            let res = await LocationPaymentProcessorApis.delete(obj.id);
            this.va_spinner(false);
            this.snackbar.add({
                type: 'info',
                text: res.status == 200 ? res.data.message : Helpers.catchErrorMessage(res.response.data),
                duration: 3000,
            })
            if (res.status == 200) {
                this.emitter.emit("refresh-location-payment-processor-list", true);
                this.clearComponent();
            }
        },

        ...mapActions({
            va_spinner: 'spinner/setSpinner',
        })
    },
});
</script>
